const CONTENT_API = "/api";

export default {
  map: {
    mapFilters: `${CONTENT_API}/map/filters`,
    mapSearchList: `${CONTENT_API}/map/search`,
    mapMarkers: `${CONTENT_API}/map/markers`,
    mapFiltersV2: `${CONTENT_API}/v2/map/filters`,
    mapSearchListV2: `${CONTENT_API}/v2/map/search`,
    mapMarkersV2: `${CONTENT_API}/v2/map/markers`,
    reverseGeocoding: (lat: number, lng: number) => `${CONTENT_API}/map/reverseGeocoding?lat=${lat}&lng=${lng}`,
  },
  form: {
    submitRecaptcha: `${CONTENT_API}/recaptcha/submit-form`,
  },
  setCookies: `${CONTENT_API}/cookies`,
  supplier: {
    details: (supplierId: string) => `${CONTENT_API}/supplier/${supplierId}`,
  },
  supplierV2: {
    details: (supplierId: string, subscriptionModel: number) => `${CONTENT_API}/v2/supplier/${supplierId}?subscription-model=${subscriptionModel}`,
  },
  table: {
    filters: `${CONTENT_API}/table/filters`,
    facilities: `${CONTENT_API}/table/facilities`,
  },
  section: {
    levels: `${CONTENT_API}/section/levels`,
  }
};
